import React from 'react';
import { BookingButton } from '../components/BookingButton';
import { Accordion } from '../components/Accordion';
import { FooterCTA } from '../components/FooterCTA';
import { testimonials } from '../components/testimonials';
import { TestimonialCard } from '../components/TestimonialCard';
export function ProviToolkit() {
  const faqs = [{
    question: 'În ce format primesc instrumentele?',
    answer: 'Primești acces imediat după plată la un folder cu toate fișierele în format Google Docs și Google Sheets, gata de copiat și personalizat. Lecțiile video sunt accesibile online, pe platforma ProVi, fără limită de timp.'
  }, {
    question: 'Trebuie să am cunoștințe tehnice ca să le folosesc?',
    answer: 'Nu. Fiecare instrument vine cu un ghid video în care Valer explică pas cu pas cum se completează și cum se citesc rezultatele. Dacă știi să folosești Google Docs și Google Sheets, ești gata.'
  }, {
    question: 'Cât timp îmi ia să aplic toate instrumentele?',
    answer: 'Poți aplica primul instrument, Organizatorul Viziune și Strategie, în prima zi. Toolkit-ul complet se implementează gradual în 2 până la 4 săptămâni, câte un instrument pe săptămână, fără să îți perturbe activitatea curentă.'
  }, {
    question: 'Funcționează și dacă am o echipă mică, de 3 până la 5 oameni?',
    answer: 'Da, de fapt pentru echipele mici impactul este cel mai rapid vizibil. Cu cât echipa e mai mică, cu atât un instrument simplu de urmărire și un ritm de ședință clar fac o diferență imediată.'
  }, {
    question: 'Pot folosi aceste instrumente și cu echipa mea de lideri?',
    answer: 'Exact pentru asta sunt gândite. Tabela de marcaj, modelul de ședință și radarul oamenilor sunt instrumente de echipă, nu individuale. Le introduci în ședința ta săptămânală și le completați împreună.'
  }, {
    question: 'Ce se întâmplă dacă vreau mai mult după ce aplic toolkit-ul?',
    answer: 'ProVi Toolkit este primul nivel din ecosistemul ProVi System. Dacă după aplicare simți că ai nevoie de implementare mai profundă, poți accesa workshopul, programul de grup sau implementarea completă de 12 luni. Suma plătită pe toolkit se deduce din investiția în programele superioare.'
  }];
  return <div className="w-full min-h-screen bg-[#09111F] overflow-x-hidden pt-20" data-id="element-867">
      {/* SECTION 1 — HERO */}
      <section className="w-full bg-[#09111F] relative overflow-hidden py-20 md:py-32" data-id="element-868">
        <div className="max-w-[900px] mx-auto px-5 md:px-12 text-center relative z-10" data-id="element-869">
          <div className="inline-flex items-center gap-2 bg-[rgba(29,78,216,0.15)] border border-[rgba(29,78,216,0.3)] px-4 py-2 rounded-full mb-8" data-id="element-870">
            <span className="font-['Montserrat'] text-[11px] font-bold tracking-[0.15em] uppercase text-[#3B82F6]" data-id="element-871">
              PRODUS DIGITAL
            </span>
          </div>
          <h1 className="font-['Montserrat'] text-[clamp(40px,5vw,64px)] font-extrabold text-white leading-[1.1] mb-6" data-id="element-872">
            ProVi Toolkit
          </h1>
          <p className="font-['Inter'] text-[20px] md:text-[24px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6] mb-10" data-id="element-873">
            Instrumentele simple, clare, aplicabile de azi, cu care pui ordine
            în afacere!
          </p>
          <BookingButton text="Vreau ProVi Toolkit — 97 €" className="px-10 py-5 text-[16px]" data-id="element-874" />
        </div>
      </section>

      {/* SECTION 2 — DESCRIERE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-875">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-876">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-8 text-center" data-id="element-877">
            Știi că ceva nu funcționează cum trebuie. Dar nu știi de unde să
            începi.
          </h2>
          <div className="space-y-6 font-['Inter'] text-[18px] text-[#4B5563] leading-[1.8]" data-id="element-878">
            <p data-id="element-879">
              Ești antreprenor sau lider de departament cu rezultate decente,
              dar simți că afacerea sau echipa ta funcționează haotic. Nu ai o
              direcție scrisă pe care toată lumea să o urmeze.
            </p>
            <p data-id="element-880">
              Nu ai cifre clare urmărite săptămânal. Ședințele se țin, dar nu se
              termină cu nimic concret. Aceleași probleme revin lună după lună.
            </p>
            <p data-id="element-881">
              Fără instrumente clare, haosul devine norma. Fiecare zi se consumă
              în urgențe, nu în direcție. Echipa improvizează pentru că nu are
              un cadru. Tu improvizezi pentru că nu ai timp să construiești
              unul.
            </p>
            <p className="font-bold text-[#09111F]" data-id="element-882">
              ProVi Toolkit este setul de instrumente practice extrase direct
              din ProVi System, gândit pentru antreprenorul care vrea să înceapă
              să pună ordine singur, fără consultant.
            </p>
            <p data-id="element-883">
              Primești lecțiile video care explică fiecare unealtă și
              template-urile gata de folosit pentru viziune, oameni, cifre și
              ritm de ședințe. Descarci, urmezi pașii și aplici de azi.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3 — CE PRIMEȘTI */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-884">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-885">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-16 text-center" data-id="element-886">
            Ce primești în ProVi Toolkit și la ce îți folosește fiecare
            instrument
          </h2>
          <div className="space-y-8" data-id="element-887">
            {[{
            title: 'Organizatorul Viziune & Strategie',
            items: ['Template structurat în care documentezi direcția companiei, obiectivele anului și prioritățile trimestrului curent', 'Ghid video pas cu pas care îți explică cum să completezi viziunea astfel încât să poată fi comunicată și urmărită de toată echipa', 'Format gata de prezentat în prima ședință cu liderii tăi, fără pregătire suplimentară']
          }, {
            title: 'Tabela de Marcaj & Lista de Probleme',
            items: ['Tablou de bord săptămânal care îți arată în 10 minute cifrele care contează și abaterile față de target', 'Sistem simplu de înregistrare a problemelor recurente cu câmpuri pentru cauză, responsabil și termen de rezolvare', 'Video de introducere care îți explică ce indicatori să urmărești în funcție de etapa afacerii tale']
          }, {
            title: 'Modelul de Ședință Puls 10 & Planul Trimestrial',
            items: ['Agendă standard pentru ședința săptămânală de echipă de 10 minute cu structură fixă: cifre, probleme, priorități, asumare', 'Template de plan trimestrial cu obiectiv principal, priorități și acțiuni cu responsabili și termene clare', 'Video care arată cum să conduci prima ședință Puls 10 astfel încât echipa să adopte ritmul fără rezistență']
          }, {
            title: 'Radarul Oamenilor Potriviți',
            items: ['Diagramă vizuală în care plasezi fiecare om din echipă în funcție de aliniere la valori și la cerințele rolului', 'Ghid de interpretare care îți explică ce înseamnă fiecare zonă a radarului și ce decizie urmează în fiecare caz', 'Video în care Valer explică cele mai frecvente greșeli de plasare a oamenilor în roluri și cum să le eviți']
          }, {
            title: 'Instrumentul de Urmărire Cash',
            items: ['Tablou simplu de urmărire a intrărilor, ieșirilor și marjelor cu vizualizare lunară și trimestrială', 'Câmpuri predefinite pentru cele mai importante categorii de costuri și venituri din orice tip de afacere', 'Video scurt care îți arată cum să citești tabloul în 5 minute și ce decizie implică fiecare scenariu']
          }].map((block, i) => <div key={i} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100" data-id="element-888">
                <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#1D4ED8] mb-4" data-id="element-889">
                  {block.title}
                </h3>
                <ul className="space-y-3" data-id="element-890">
                  {block.items.map((item, j) => <li key={j} className="flex items-start gap-3" data-id="element-891">
                      <div className="w-2 h-2 rounded-full bg-[#1D4ED8] mt-2 flex-shrink-0" data-id="element-892"></div>
                      <span className="font-['Inter'] text-[16px] text-[#4B5563] leading-[1.6]" data-id="element-893">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 4 — BENEFICII */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-894">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-895">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-16 text-center" data-id="element-896">
            Ce obții concret cu ProVi Toolkit
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-897">
            {[{
            title: 'Claritate în 30 de minute',
            desc: 'Organizatorul Viziune și Strategie se completează într-o singură sesiune și îți dă imediat o direcție documentată, comunicabilă și urmăribilă de toată echipa.'
          }, {
            title: 'Control săptămânal fără efort',
            desc: 'Tabela de marcaj se actualizează în 10 minute pe săptămână și îți arată tot ce trebuie să știi despre starea afacerii tale.'
          }, {
            title: 'Ședințe care produc rezultate',
            desc: 'Modelul Puls 10 transformă ședințele haotice în întâlniri scurte, concentrate și cu acțiuni clare asumate de fiecare participant.'
          }, {
            title: 'Echipă în rolurile potrivite',
            desc: 'Radarul Oamenilor Potriviți îți arată în câteva minute unde sunt nepotrivirile din echipă care te costă timp și energie în fiecare lună.'
          }, {
            title: 'Cash sub control',
            desc: 'Instrumentul de urmărire cash elimină surprizele financiare și îți dă curajul să iei decizii de creștere pe cifre reale, nu pe estimări.'
          }, {
            title: 'Lecții video care explică totul pas cu pas',
            desc: 'Nu primești template-uri goale. Primești lecțiile video în care Valer explică exact cum și când se aplică fiecare instrument.'
          }, {
            title: 'Aplicabil de azi',
            desc: 'Toate instrumentele sunt gata de folosit imediat după descărcare. Fără teorie lungă, fără pregătire specială.'
          }].map((benefit, i) => <div key={i} className="bg-[#F1F5F9] rounded-2xl p-6" data-id="element-898">
                <h3 className="font-['Montserrat'] text-[18px] font-bold text-[#09111F] mb-3" data-id="element-899">
                  {benefit.title}
                </h3>
                <p className="font-['Inter'] text-[15px] text-[#4B5563] leading-[1.6]" data-id="element-900">
                  {benefit.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 5 — CINE SUNT EU */}
      <section className="w-full bg-[#0A1628] py-16 md:py-24 text-white" data-id="element-901">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-902">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold mb-8 text-center" data-id="element-903">
            Cine a construit aceste instrumente și de ce poți să ai încredere în
            ele
          </h2>
          <div className="space-y-6 font-['Inter'] text-[18px] font-light text-[rgba(255,255,255,0.8)] leading-[1.8]" data-id="element-904">
            <p data-id="element-905">
              Sunt Valer Dura. Am construit, eficientizat și vândut propriile
              afaceri cu cifre de milioane de euro. Nu am inventat aceste
              instrumente citind cărți de business. Le-am construit și rafinat
              în 12 ani de lucru direct cu antreprenori și echipe de lideri din
              companii românești reale.
            </p>
            <p data-id="element-906">
              ProVi Toolkit nu este o colecție de template-uri descărcate de pe
              internet și rebranduite. Este setul exact de instrumente pe care
              îl folosesc în programul de implementare de 12 luni cu clienții
              mei, simplificat pentru a fi aplicabil de oricine, fără să fie
              nevoie de un implementator alături.
            </p>
            <p data-id="element-907">
              Am ales să scot aceste instrumente ca produs separat pentru că
              știu că există antreprenori care nu sunt pregătiți încă pentru un
              program complet, dar care au nevoie imediat de un punct de plecare
              concret. ProVi Toolkit este acel punct de plecare.
            </p>
            <p className="font-medium text-white border-l-4 border-[#3B82F6] pl-6 py-2" data-id="element-908">
              Dacă după ce aplici toolkit-ul simți că ai nevoie de mai mult,
              sunt aici. Dacă toolkit-ul rezolvă ce ai nevoie, cu atât mai bine.
              În ambele cazuri, afacerea ta iese mai bine decât a intrat.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 6 — PENTRU CINE ESTE / NU ESTE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-909">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-910">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-911">
            <div className="bg-[#EFF6FF] rounded-3xl p-8 border border-[rgba(59,130,246,0.2)]" data-id="element-912">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6" data-id="element-913">
                ProVi Toolkit este pentru tine dacă
              </h3>
              <ul className="space-y-4" data-id="element-914">
                {['Ești antreprenor cu echipă și lucrezi mult, dar fără o direcție clară documentată', 'Ești lider de departament care vrea un sistem simplu de urmărire a echipei și a rezultatelor', 'Vrei să pui ordine în afacere singur, fără să angajezi un consultant în această etapă'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-915">
                    <div className="w-2 h-2 rounded-full bg-[#1D4ED8] mt-2 flex-shrink-0" data-id="element-916"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-917">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-[#FEF2F2] rounded-3xl p-8 border border-[rgba(239,68,68,0.2)]" data-id="element-918">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6" data-id="element-919">
                ProVi Toolkit nu este pentru tine dacă
              </h3>
              <ul className="space-y-4" data-id="element-920">
                {['Ești la primul angajat sau nu ai echipă, instrumentele nu au unde să se aplice încă', 'Cauți o soluție care să funcționeze fără niciun efort de implementare din partea ta', 'Ai nevoie de cineva care să vină în compania ta și să facă schimbările alături de echipă'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-921">
                    <div className="w-2 h-2 rounded-full bg-[#EF4444] mt-2 flex-shrink-0" data-id="element-922"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-923">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 — RECAPITULARE INVESTIȚIE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-924">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-925">
          <div className="bg-white rounded-3xl p-8 md:p-12 border-2 border-[#1D4ED8] shadow-[0_20px_40px_rgba(29,78,216,0.08)] relative" data-id="element-926">
            <div className="absolute -top-4 inset-x-0 flex justify-center" data-id="element-927">
              <span className="bg-[#1D4ED8] text-white font-['Montserrat'] text-[12px] font-bold tracking-[0.15em] uppercase px-6 py-2 rounded-full shadow-md" data-id="element-928">
                RECAPITULARE
              </span>
            </div>
            <h2 className="font-['Montserrat'] text-[28px] md:text-[36px] font-bold text-[#09111F] mb-8 text-center mt-4" data-id="element-929">
              Hai să recapitulăm ce primești și cât investești pentru ProVi
              Toolkit
            </h2>

            <div className="flex flex-col gap-10" data-id="element-930">
              <div data-id="element-931">
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#1D4ED8] mb-6" data-id="element-932">
                  Ce este inclus:
                </h3>
                <ul className="space-y-4" data-id="element-933">
                  {['Organizatorul Viziune & Strategie cu ghid video (Valoare: 59 €)', 'Tabela de Marcaj & Lista de Probleme cu video de introducere (Valoare: 59 €)', 'Modelul de Ședință Puls 10 & Planul Trimestrial cu video de facilitare (Valoare: 59 €)', 'Radarul Oamenilor Potriviți cu ghid de interpretare și video (Valoare: 59 €)', 'Instrumentul de Urmărire Cash cu video de citire (Valoare: 59 €)'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-934">
                      <svg className="w-5 h-5 text-[#1D4ED8] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-935">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-936"></path>
                      </svg>
                      <span className="font-['Inter'] text-[16px] text-[#4B5563] leading-[1.6]" data-id="element-937">
                        {item}
                      </span>
                    </li>)}
                </ul>
                <p className="font-['Montserrat'] text-[18px] font-bold text-[#6B7280] mt-6" data-id="element-938">
                  Valoare totală reală: 295 € dacă ai cumpăra fiecare instrument
                  separat
                </p>
              </div>
              <div data-id="element-939">
                <div className="bg-[#FEF2F2] rounded-xl p-6 border border-[rgba(239,68,68,0.2)] text-center" data-id="element-940">
                  <p className="font-['Montserrat'] text-[14px] font-bold text-[#EF4444] uppercase tracking-wider mb-2" data-id="element-941">
                    PREȚUL SPECIAL:
                  </p>
                  <p className="font-['Montserrat'] text-[56px] font-extrabold text-[#09111F] leading-none" data-id="element-942">
                    97 €
                  </p>
                  <p className="font-['Inter'] text-[15px] text-[#6B7280] mt-2" data-id="element-943">
                    în loc de 295 €
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-12 text-center" data-id="element-944">
              <BookingButton text="Cumpără Acum ProVi Toolkit" className="px-10 py-5 text-[16px] w-full sm:w-auto" data-id="element-945" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8 — TESTIMONIALE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-946">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-947">
          <div className="text-center mb-16" data-id="element-948">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F]" data-id="element-949">
              Ce spun antreprenorii care folosesc instrumentele ProVi System
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-950">
            {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-951" />)}
          </div>
        </div>
      </section>

      {/* SECTION 9 — ÎNTREBĂRI FRECVENTE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-952">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-953">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-12 text-center" data-id="element-954">
            Întrebări Frecvente
          </h2>
          <div className="space-y-4" data-id="element-955">
            {faqs.map((faq, index) => <Accordion key={index} title={faq.question} content={faq.answer} data-id="element-956" />)}
          </div>
        </div>
      </section>

      <FooterCTA data-id="element-957" />
    </div>;
}